export type RouteExpenseStatus = 'DRAFT' | 'CONFIRMED' | 'REJECTED';

export type ExpenseStatusAudience = 'logist' | 'accountant';

export function normalizeRouteExpenseStatus(status: string | null | undefined): RouteExpenseStatus {
  const s = String(status || 'DRAFT').toUpperCase();
  if (s === 'CONFIRMED' || s === 'REJECTED') return s;
  return 'DRAFT';
}

/** Logist-facing labels (DRAFT saved = sent to accountant). */
export function routeExpenseStatusLabel(
  status: string | null | undefined,
  audience: ExpenseStatusAudience = 'logist',
  options?: { persisted?: boolean }
): string {
  const s = normalizeRouteExpenseStatus(status);
  if (audience === 'accountant') {
    if (s === 'DRAFT') return 'Требует подтверждения';
    if (s === 'CONFIRMED') return 'Подтверждено';
    return 'Отклонено';
  }
  if (s === 'CONFIRMED') return 'Подтверждено';
  if (s === 'REJECTED') return 'Отклонено';
  return options?.persisted ? 'Отправлено бухгалтеру' : 'Черновик';
}

export function routeExpenseStatusTagColor(
  status: string | null | undefined
): 'default' | 'processing' | 'success' | 'error' {
  const s = normalizeRouteExpenseStatus(status);
  if (s === 'CONFIRMED') return 'success';
  if (s === 'REJECTED') return 'default';
  return 'processing';
}
